import { render, staticRenderFns } from "./EmailAddressDetails.vue?vue&type=template&id=00dca603&"
import script from "./EmailAddressDetails.vue?vue&type=script&lang=js&"
export * from "./EmailAddressDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00dca603')) {
      api.createRecord('00dca603', component.options)
    } else {
      api.reload('00dca603', component.options)
    }
    module.hot.accept("./EmailAddressDetails.vue?vue&type=template&id=00dca603&", function () {
      api.rerender('00dca603', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/email/EmailAddressDetails.vue"
export default component.exports